import React, { Suspense } from "react";
import 'lantmannen-common-widget/dist/main.css';
import { HashRouter as Router, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react'
import configureStore from "./store";

import {
  Preloader,
  Theme,
  Widget
} from "lantmannen-common-widget";

import {
  DefaultHeader,
  ConnectedSnackbar,
  ConnectedPreloader
} from "./components/common";

const FirstPage = React.lazy(() => import("./components/screens/FirstPage"));
const WeedsPage = React.lazy(() => import("./components/screens/WeedsPage"));
const StrategiesPage = React.lazy(() => import("./components/screens/StrategiesPage"));
const ComparePage = React.lazy(() => import("./components/screens/ComparePage"));

const {store, persistor} = configureStore();

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={<Preloader fixed />} persistor={persistor}>
        <Suspense fallback={<Preloader fixed />}>
          <Router>
            <Theme>
              <Widget>
                <DefaultHeader></DefaultHeader>
                <Route exact path="/" component={FirstPage} />
                <Route exact path="/weeds" component={WeedsPage} />
                <Route exact path="/strategies" component={StrategiesPage} />
                <Route exact path="/compare" component={ComparePage} />
                <ConnectedSnackbar />
                <ConnectedPreloader />
              </Widget>
            </Theme>
          </Router>
        </Suspense>
      </PersistGate>
    </Provider>
  );
};

export default App;
